export const FacebookLoginStatus = {
  Connected: "connected", //user is logged into facebook and has authorized the app
  NotAuthorized: "not_authorized", //user is logged into facebook and has not authorized the app
  Unknown: "unknown", //user is not logged into facebook and has not authorized the app
};
